// Returns true when every character of query appears in text in the same
// order (case-insensitive, whitespace in the query is ignored).
export const fuzzyMatch = (text = "", query = "") => {
  const t = String(text).toLowerCase();
  const q = String(query).toLowerCase().replace(/\s+/g, "");
  let ti = 0;
  for (let qi = 0; qi < q.length; qi++) {
    ti = t.indexOf(q[qi], ti);
    if (ti === -1) return false;
    ti += 1;
  }
  return true;
};

// Filters tree nodes ({ name, isFolder, isOpen, items }) down to the ones whose
// name fuzzy-matches the query. Folders are kept when they match themselves
// (with all their children) or when any descendant matches (with only the
// matching descendants), and are forced open so results are visible.
export const fuzzyFilterTree = (nodes, query) => {
  if (!query || !String(query).trim()) return nodes;

  const filterNode = (node) => {
    if (!node || typeof node !== "object") return null;
    if (node.isFolder) {
      const selfMatch = fuzzyMatch(node.name, query);
      const items = (node.items || []).map(filterNode).filter(Boolean);
      if (selfMatch) {
        return { ...node, isOpen: true, items: items.length ? items : node.items || [] };
      }
      if (items.length > 0) {
        return { ...node, isOpen: true, items };
      }
      return null;
    }
    return fuzzyMatch(node.name, query) ? node : null;
  };

  return (nodes || []).map(filterNode).filter(Boolean);
};
